var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
import { parseError } from "./expapiv2/ExpApiV2.utils.js";
import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let SubscriberResources = class extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.notificationHub, "", parseError);
  }
  loadSubscribers(payload) {
    return __async(this, null, function* () {
      let address = `/workspaces/${payload.workspaceId}/notification-subscriptions/${payload.entityType}/${payload.entityExternalId}/subscribers?fetchPhoto=${payload.fetchPhoto}&includeUser=${payload.includeUser}`;
      const result = yield this._get(address);
      return result;
    });
  }
  search(payload) {
    return __async(this, null, function* () {
      const searchStrEncoded = encodeURIComponent(payload.searchStr);
      let address = `/workspaces/${payload.workspaceId}/notification-subscriptions/subscribers/search?searchStr=${searchStrEncoded}&count=${payload.count}&fetchUserPhoto=${payload.fetchPhoto}&domains=${payload.domains}`;
      const result = yield this._get(address);
      return result;
    });
  }
  setSubscribers(putParams) {
    return __async(this, null, function* () {
      let address = `/workspaces/${putParams.workspaceId}/notification-subscriptions`;
      const result = yield this._put(putParams, address);
      return result;
    });
  }
  getSubscriberDisplayNamesByEntities(payload) {
    return __async(this, null, function* () {
      let address = `/workspaces/${payload.workspaceId}/notification-subscriptions/${payload.entityType}/subscriberDisplayNames?api-version=1.0-preview.1`;
      const result = yield this._post(payload.entityExternalIds, address);
      return result;
    });
  }
};
SubscriberResources = __decorateClass([
  WPSProxyConverter()
], SubscriberResources);
const SubscriberResources$1 = new SubscriberResources();
export {
  SubscriberResources$1 as default
};
//# sourceMappingURL=SubscriberResources.js.map
